import React from 'react';
import css from './styles.module.scss';
import SearchIcon from '@material-ui/icons/Search';
import { InputBase } from '@material-ui/core';
import classNames from 'classnames';

interface SearchProps {
    search: string;
    onSearchChange: (newSearch: string) => void;
    className?: string;
}

export const Search: React.FC<SearchProps> = ({ search, onSearchChange, className }) => {
    return (
        <div className={classNames(css.module, className)}>
            <div className={css.searchIcon}>
                <SearchIcon />
            </div>
            <InputBase
                classes={{
                    root: css.inputRoot,
                    input: css.inputInput,
                }}
                value={search}
                onChange={e => onSearchChange(e.target.value)}
            />
        </div>
    );
};
